import { Injectable } from "@angular/core";
import moment from 'moment';
import { FormArray, FormControlStatus, FormGroup } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  HttpProviderService,
  IHttpSuccessPayload,
  RoutingInfo,
  BaseFpxChangeHandler,
  BaseFpxControlEventHandler,
  HttpRequest,
  SpinnerService,
  ILookupResponse,
  FpxModal,
  CriteriaQuery,
} from "@fpx/core";
import { BehaviorSubject, Observable, map, of } from "rxjs";
import { Router } from "@angular/router";

import { Rloapplication } from "../rloapplication-service/rloapplication.model";
import { PopupService } from "src/app/common/services/popup/popup.service";
import { MatDialogRef } from "@angular/material/dialog";
import { RloApplicationFilterFormComponent } from "./rloapplication-filter-form.component";
import { RloapplicationService } from "../rloapplication-service/rloapplication.service";
import { CommonService } from "src/app/common.service";

export class RloApplicationFilterFormState extends BaseFpxComponentState {
  showSuggestion: boolean = false;
}

@Injectable()
export class RloApplicationFilterFormHelper extends BaseFpxFormHelper<RloApplicationFilterFormState> {
  applicantName:any;
  arn:any;
  type:any;
  period:any;
  stage:any;
  tat:any;
  criteriaQuery=new CriteriaQuery();
  action: number;

  constructor(
    private _popupService: PopupService,
    private dialogRef: MatDialogRef<RloApplicationFilterFormComponent>,
    private _httpProvider: HttpProviderService,
    private _router: Router,
    public _rloapplicationService:RloapplicationService,
    public _commonService: CommonService
  ) {
    super(new RloApplicationFilterFormState());
  }

  override doPreInit(): void {}

  public override doPostInit(): void {
    this.action=0;
    if(this._rloapplicationService.filterApplied){
      if (this._rloapplicationService.filter_applicantName)
        this.formGroup.get('applicantName').patchValue(this._rloapplicationService.filter_applicantName);
      if (this._rloapplicationService.filter_arn)
        this.formGroup.get('arn').patchValue(this._rloapplicationService.filter_arn);
      if (this._rloapplicationService.filter_type)
        this.formGroup.get('type').patchValue(this._rloapplicationService.filter_type);
      if (this._rloapplicationService.filter_period)
        this.formGroup.get('period').patchValue(this._rloapplicationService.filter_period);
      if (this._rloapplicationService.filter_stage)
        this.formGroup.get('stage').patchValue(this._rloapplicationService.filter_stage);
      if (this._rloapplicationService.filter_tat)
        this.formGroup.get('tat').patchValue(this._rloapplicationService.filter_tat);
      }
  }

  public override preSubmitInterceptor(payload: Rloapplication): any {
    // WRITE CODE HERE TO HANDLE
    return payload;
  }

  public override postSubmitInterceptor(response: any): RoutingInfo {
    console.log(response);
    let routingInfo: RoutingInfo = new RoutingInfo();
    routingInfo.setNavigationURL("confirmation");
    if (response.success) {
      routingInfo.setQueryParams({
        status: "success",
      });
    } else if (response.error) {
      routingInfo.setQueryParams({ status: "failed" });
    }
    return routingInfo;
  }
  //$START_CUSTOMSCRIPT\n
  closeFilter(action: string = "") {
    if(this.action==1)
      this.dialogRef.close(1);
    else
      this.dialogRef.close();
  }
  resetFilterData(){
    this._rloapplicationService.criteriaQuery._filterCriteria=new Map();
    this._rloapplicationService.filter_applicantName="";
    this._rloapplicationService.filter_arn=null;
    this._rloapplicationService.filter_type="";
    this._rloapplicationService.filter_period="";
    this._rloapplicationService.filter_stage="";
    this._rloapplicationService.filter_tat="";
  }
  clearFilter() {
    this.formGroup.reset();
    this._rloapplicationService.filterApplied=false;
    this.resetFilterData();
    this.action=1;
  }
  applyFilter() {
    this._rloapplicationService.filterApplied=false;
    this.applicantName = this.formGroup.get("applicantName").value;
    this.arn = this.formGroup.get("arn").value;
    this.type = this.formGroup.get("type").value;
    this.period = this.formGroup.get("period").value;
    this.stage = this.formGroup.get("stage").value;
    this.tat = this.formGroup.get("tat").value;

    if(this._rloapplicationService.sortApplied)
      this.criteriaQuery = this._rloapplicationService.criteriaQuery;


    if (this.applicantName){
      this._rloapplicationService.filter_applicantName=this.applicantName;
      this._rloapplicationService.filterApplied=true;
      this.criteriaQuery.addFilterCritertia(
        this._rloapplicationService.applicantNameColumn, "String", "Contains", {
        searchText: this.applicantName,
      });
    }
    if (this.arn){
      this._rloapplicationService.filter_arn=this.arn;
      this._rloapplicationService.filterApplied=true;
      this.criteriaQuery.addFilterCritertia(
        this._rloapplicationService.arnColumn, "String", "Contains", {
        searchText: this.arn,
      });
    }
    if (this.type){
      this._rloapplicationService.filter_type=this.type;
      let Priority=[];
      this.type.forEach(element => {
        if(element==(this._rloapplicationService.typeData[element-1].id))
          Priority.push(this._rloapplicationService.typeData[element-1].text);
      });
      if(Priority.length) this._rloapplicationService.filterApplied=true;
      this.criteriaQuery.addFilterCritertia(
        this._rloapplicationService.typeColumn, "String", "in",{
          searchText: Priority[Priority.length-1]
         });
    }
    if (this.period){
      this._rloapplicationService.filter_period=this.period;
      let createdOn=[];
      let periodid: string = "1";
      this.period.forEach(element => {
        if(element==(this._rloapplicationService.periodData[element-1].id)){
          periodid = this._rloapplicationService.periodData[element-1].id;
          createdOn.push(this._rloapplicationService.periodData[element-1].text);
        }
      });
      if(createdOn.length) this._rloapplicationService.filterApplied=true;
      let toDate:any= moment().format("YYYY-MM-DD");
      let startDate: any;
      switch(periodid) {
        case "1": 
          startDate = moment().subtract(1, "days").format("YYYY-MM-DD");
          break;
        case "2":
          startDate = moment().subtract(1, "weeks").format("YYYY-MM-DD");
          break;
        case "3":
          startDate = moment().subtract(1, "months").format("YYYY-MM-DD");
          break;
        case "4":
          startDate = moment().subtract(3, "months").format("YYYY-MM-DD");
          break;
        case "5":
          startDate = moment().subtract(6, "months").format("YYYY-MM-DD");
          break;
        case "6":
          startDate = moment().subtract(9, "months").format("YYYY-MM-DD");
          break;
        case "7":
          startDate = moment().subtract(1, "years").format("YYYY-MM-DD");
          break;
      }
      this.criteriaQuery.addFilterCritertia(
        this._rloapplicationService.periodColumn, "String", "inRange", {
          dateFrom: startDate,
          dateTo: toDate
        // searchText: createdOn[createdOn.length-1],
      });
    }
    if (this.stage){
      this._rloapplicationService.filter_stage=this.stage;
      let formName=[], arr = [], self = this;
      let stageid = "";
      this.stage.forEach(element => {
        formName = formName.concat(this._rloapplicationService.stageData.filter((item) => {
          return item.id == element;
        }))
      });
      if(formName.length) {
        stageid = formName[formName.length-1].id;
        this._rloapplicationService.filterApplied=true;
        this.criteriaQuery.addFilterCritertia(
          this._rloapplicationService.stageColumn, "String", "in", {
          searchText: formName[formName.length-1].id,
        });
      }
    }
    if (this.tat){
      this._rloapplicationService.filter_tat=this.tat;
      let tatBurstOn=[];
      let tatid = "1";
      this.tat.forEach(element => {
        if(element==(this._rloapplicationService.tatData[element-1].id)){
          tatid = this._rloapplicationService.tatData[element-1].id;
          tatBurstOn.push(this._rloapplicationService.tatData[element-1].text);
        }
      });
      if(tatBurstOn.length) this._rloapplicationService.filterApplied=true;
      let toDate:any= moment().format("YYYY-MM-DD");
      let startDate: any;
      switch(tatid) {
        case "1": 
          startDate = moment().subtract(1, "days").format("YYYY-MM-DD");
          break;
        case "2":
          startDate = moment().subtract(1, "weeks").format("YYYY-MM-DD");
          break;
        case "3":
          startDate = moment().subtract(1, "months").format("YYYY-MM-DD");
          break;
        case "4":
          startDate = moment().subtract(3, "months").format("YYYY-MM-DD");
          break;
        case "5":
          startDate = moment().subtract(6, "months").format("YYYY-MM-DD");
          break;
        case "6":
          startDate = moment().subtract(9, "months").format("YYYY-MM-DD");
          break;
        case "7":
          startDate = moment().subtract(1, "years").format("YYYY-MM-DD");
          break;
      }
      this.criteriaQuery.addFilterCritertia(this._rloapplicationService.tatColumn, "String", "inRange", {
        dateFrom: startDate,
        dateTo: toDate
      });
    }
    this._rloapplicationService.criteriaQuery=this.criteriaQuery;
    this.dialogRef.close(1);
    this._commonService.showSpinner();
  }
  //$END_CUSTOMSCRIPT\n
}
